import React from 'react'

const ConsejosCard = ({mostrarConsejos}) => {
  var currentCat = "Climatización";
  if(typeof mostrarConsejos !== "undefined"){
    currentCat = mostrarConsejos;
  }

  /** 
   * Artefactos en General 
   */ 
  let artefactoDetalle = 
  <p className={"text-justify"}>
    El consumo de energía está asociado con el tiempo de funcionamiento del equipo, por eso la clave es usar sólo lo necesario.
  </p>
  let heladera = 
  <ul className={"list-disc pl-4"}>
    <li>Mantener la parte trasera limpia y ventilada.</li>
    <li>Ubicarla lejos de los focos de calor y a 15 cm de la pared.</li>
    <li>Verificar los burletes de la puerta.</li>
    <li>No introducir comidas calientes.</li>
    <li>No abrir la puerta inútilmente o por tiempos prolongados.</li>
    <li>Descongelarla periódicamente.</li>
  </ul>;  
  let lavarropas =
  <ul className={"list-disc pl-4"}>
    <li>Procurar siempre lavar con agua fría.</li>
    <li>Utilizar siempre su capacidad máxima (al igual que en los secarropas).</li>
  </ul>;
    
  let calefones = 
  <ul className={"list-disc pl-4"}>
    <li>Ajustar el termostato para obtener una temperatura ligeramente superior a los 40°C.</li>
    <li>No prolongar inútilmente el tiempo de las duchas.</li>
  </ul>;
  let plancha = 
  <ul className={"list-disc pl-4"}>
    <li>Mantener la superficie de la plancha limpia.</li>
    <li>Acumular ropa y no planchar prendas por separado.</li>
    <li>Desenchufarla antes de terminar y utilizar el calor remanente.</li>
  </ul>
  let teleAudioCompus = 
  <ul className={"list-disc pl-4"}>
    <li>Apagarlos mientras no se utilizan.</li>
    <li>No dejarlos en “stand by”.</li>
    <li>Configurar la opción de ahorro para el monitor.</li>
  </ul>

  /** 
   * Usuarios Responsables
   */
  let usuariosResponsablesDetalle = 
  <p className={"text-justify"}>
    El aporte de los usuarios es fundamental para el uso eficiente y racional de la energía eléctrica. Con la ayuda y colaboración de cada uno, los beneficios son para todos. Por eso los invitamos a:
  </p>;
  let usuariosResponsablesItems = 
  <ul className={"list-disc pl-4"}>
   <li>Verificar la instalación eléctrica de la vivienda para evitar pérdidas.</li> 
   <li>Apagar las luces de los ambientes que no se usan.</li> 
   <li>Aprovechar la luz natural y elegir colores claros para paredes y techos.</li> 
   <li>Usar lámparas de bajo consumo.</li> 
   <li>Apagar los electrodomésticos mientras no se utilizan.</li> 
   <li>Desenchufar el cargador del celular.</li> 
   <li>Elegir los de bajo consumo eléctrico, a la hora de comprar nuevos electrodomésticos.</li> 
  </ul>;

  /** 
   * Iluminación Eficiente 
   */
  let  iluminacionDetalle1 = 
  <ul className={"list-disc pl-4"}>
    <li>Es aquella que ilumina con el menor consumo de energía posible.</li>
    <li>El uso de lámparas fluorescentes compactas, comúnmente llamadas “lámparas de bajo consumo”, es el mejor medio para lograr una iluminación eficiente.</li>
    <li>Estas lámparas tienen una potencia de entre 7 y 23 watts, para que tengan el flujo luminoso equivalente a las incandescentes de 25 a 100 w.</li>
  </ul>
  let iluminacionDetalle2 = 
  <p className={"text-justify"}>Beneficios de las lámparas fluorescentes compactas:</p>;
  let iluminacionItems = 
  <ul className={"list-disc pl-4"}>
    <li>Consumen entre 75 y 80% menos que las comunes, aún brindando la misma luz.</li>
    <li>Duran 6 veces más que las lámparas comunes.</li>
    <li>Habitualmente, son un poco más caras que las comunes, pero el ahorro compensa el gasto adicional.</li>
    <li>Preservan el medio ambiente, usando cuidadosamente las reservas naturales disponibles.</li>
  </ul>

  /** 
   * Aire Acondicionado 
   */
  let aireAcondicionadoDetalle = 
  <p className={"text-justify"}>
    El acondicionador de aire depende casi exclusivamente de la electricidad y su uso racional implica, por ende, un ahorro importante de energía.
  </p>;
  let aireAcondicionadoRecomendaciones = 
  <ul className={"list-disc pl-4"}>
    <li>No enfriar en exceso. Una temperatura de 24°C en verano en el interior de la vivienda brinda una suficiente sensación de bienestar. Por cada grado de temperatura por debajo de los 24°C el acondicionador consumirá aproximadamente un 5% más de energía.</li>
    <li>Instalar persianas y cortinas que impiden las radiaciones directas del sol y, por lo tanto, disminuyen la necesidad de refrigerar.</li>
    <li>Desconectar el acondicionador cuando no haya nadie en la vivienda o habitación que se está refrigerando.</li>
    <li>Revisar periódicamente el artefacto para comprobar si existen fugas de gas Freón (el fluido refrigerante). El escape de este gas impide el buen funcionamiento del equipo y daña el medio ambiente.</li>
    <li>Realizar la limpieza del filtro que atrapa la polución ambiente para mejorar el rendimiento del equipo.</li>
  </ul>;

  /** 
   * Calefacción
   */
  let calefaccionDetalle = 
  <p className={"text-justify"}>
    Cualquiera sea el tipo de calefacción que se utilice, las medidas para reducir el consumo energético se agrupan alrededor de tres ideas:
  </p>
  let calefaccionAislamiento = 
  <p className={"text-justify"}>Una parte del calor escapa de las viviendas por las paredes, puertas, ventanas, caja de las persianas, etc. Para evitarlo se recomienda:
    <ul className={"list-disc pl-4"}>
      <li>Instalar algún tipo de aislamiento térmico en paredes y techo, por ejemplo, paneles de telgopor.</li>
      <li>Instalar burletes adhesivos en los cierres de puertas exteriores y ventanas, cerrando así las rendijas</li>
    </ul>
  </p>;
  let calefaccionTemperatura = 
  <p className={"text-justify"}>En condiciones normales, la temperatura exterior con la que el cuerpo humano encuentra la sensación de bienestar es ligeramente inferior a los 20° C. Por ello:
    <ul className={"list-disc pl-4"}>
      <li>Intentar mantener la temperatura en el hogar alrededor de los 20° C.</li>
      <li>No usar la calefacción para mantener un ambiente exactamente opuesto al que impone la estación del año: estar desabrigado dentro de la casa en invierno es perjudicial para la salud y representa un consumo innecesario de energía.</li>
    </ul>
  </p>;
  let calefaccionBuenasCostumbres = 
  <ul className={"list-disc pl-4"}>
    <li>Los calentadores eléctricos tienen un consumo energético mucho mayor.</li>
    <li>Apagar la calefacción por la noche.</li>
    <li>Ventilar la casa y cerrar las ventanas antes de encender la calefacción.</li>
  </ul>

  switch (currentCat) {
    case "Climatización": 
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Climatización</h1>
                        {aireAcondicionadoDetalle}
                        <br />
                        {aireAcondicionadoRecomendaciones}
                        <br />
                        {/* {calefaccionDetalle}
                        <br /> */}
                        {/* {calefaccionAislamiento}
                        <br /> */}
                        {/* {calefaccionTemperatura}
                        <br /> */}
                        {calefaccionBuenasCostumbres}
                        <br />
                     </div>
    case "Cocina": 
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Cocina</h1>
                        {usuariosResponsablesDetalle}
                        <br />
                        {usuariosResponsablesItems}
                        <br />
                     </div>
    case "Agua":
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Agua</h1>
                        {artefactoDetalle}
                        <br />
                        {calefones}
                        <br />
                     </div>
    case "Refrigeración":
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Refrigeración</h1>
                        {artefactoDetalle}
                        <br />
                        {heladera}
                        <br />
                     </div>
    case "Cuidado Personal":
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Cuidado Personal</h1>
                        {artefactoDetalle}
                        <br />
                     </div>
    case "Electrónica, Audio y Video":
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Electrónica, Audio y Video</h1>
                        {artefactoDetalle}
                        <br />
                        {teleAudioCompus}
                        <br />
                     </div>
    case "Línea Blanca":
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Línea Blanca</h1>
                        {artefactoDetalle}
                        <br />
                        {lavarropas}
                        <br />
                        {plancha}
                        <br />
                     </div>
    case "Iluminación":
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Iluminación</h1>
                        <p>Iluminación Eficiente</p>
                        {iluminacionDetalle1}
                        <br />
                        {iluminacionDetalle2}
                        <br />
                        {iluminacionItems}
                        <br />
                     </div>
    case "Maquinaria":
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <h1 className={"text-xl font-bold text-green-700 | mb-4"}>Maquinaria</h1>
                        {usuariosResponsablesDetalle}
                        <br />
                        {usuariosResponsablesItems}
                        <br />
                     </div>
    default: 
              return <div className="w-full bg-gray-100 bg-opacity-100 rounded-md border border-solid border-green-600 | py-4 px-6 | shadow-md">
                        <p>
                          No hay consejos para mostrar
                        </p>
                    </div>
  }
}

export default ConsejosCard
